import React, { useState, useContext, useEffect } from "react";
import DataTableComponent from "react-data-table-component";

import IconButton from "@mui/material/IconButton";
import { Chip } from "@material-ui/core";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ViewListIcon from "@mui/icons-material/ViewModule";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import WalletIcon from "@mui/icons-material/AccountBalanceWallet";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

import Templete from "../../Templete/Templete";
import AuthService from "../../../../services/Admin/AuthService";
import UserService from "../../../../services/Admin/UserService";
import WalletService from "../../../../services/Admin/WalletService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

import UserDetailsDialog from "../UserDetails/UserDetailsDialog";

const UserDetailsSection = (props) => {
  const loadingCtx = useContext(LoadingContext);

  const [userType, setUserType] = useState();

  const [fromDate, setFromDate] = useState(
    new Date().toISOString().slice(0, 10),
  );
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));

  const [userData, setUserData] = useState();

  useEffect(() => {
    fetchUserById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.searchText]);

  const [userFetchLoading, setUserFetchLoading] = useState(false);

  const fetchUserById = async () => {
    const userType = await AuthService.getUserType();
    if (userType) {
      setUserType(userType);
    }

    setUserFetchLoading(true);

    try {
      const token = AuthService.getAccessToken();

      const responseData = await UserService.fetchByUserId(
        token,
        props.searchText,
      );

      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        const result = responseData.data.result;
        setUserData([result]);
        props.handleSetUserId(result.user_id);
      } else {
        setUserData();
        props.handleSetUserId("");
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    setUserFetchLoading(false);
  };

  const changeStatusHandler = async (id) => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await UserService.changeStatus(token, id);
      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        fetchUserById();
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  const history = useHistory();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectedData, setSelectedData] = useState();

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const columns = [
    {
      name: "User Type",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.user_type}</span>
        </div>
      ),
    },
    {
      name: "User ID",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.user_id}</span>
          <br />
          <span>ID: {row.id}</span>
        </div>
      ),
    },
    {
      name: "User Details",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span style={{ fontSize: "15px", fontWeight: "bold" }}>
            {row.name}
          </span>{" "}
          <br />
          <span>
            {userType === "Admin"
              ? row.mobile
              : "XXXX-XX-" + row.mobile.slice(-4)}
          </span>
          <br />
          <span>
            {userType === "Admin" ? row.email : "****" + row.email.slice(-14)}
          </span>
        </div>
      ),
    },
    {
      name: "Balance",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>
            <span
              style={{ color: "green", fontWeight: "bold", fontSize: "14px" }}
            >
              ₹
              {row.tbl_wallet_balances
                ? row.tbl_wallet_balances.length > 0
                  ? row.tbl_wallet_balances[0].main_wallet
                  : "null"
                : row.tbl_wallet_balance
                  ? row.tbl_wallet_balance.main_wallet
                  : "null"}
            </span>
          </span>
        </div>
      ),
    },

    {
      name: "Premium Status",
      cell: (row) => {
        const hasPremium = row.subscription?.some(
          (sub) => sub.package_name?.toUpperCase() === "PREMIUM",
        );

        return (
          <span
            className={`badge badge-pill ${
              hasPremium ? "bg-success" : "bg-dark"
            }`}
          >
            {hasPremium ? "SUBSCRIBED" : "FALSE"}
          </span>
        );
      },
    },
    {
      name: "KYC Status",
      cell: (row) => {
        let badgeColor;

        switch (row.kyc_status) {
          case "Verified":
            badgeColor = "success"; // green
            break;
          case "Pending":
            badgeColor = "warning"; // yellow
            break;
          case "Rejected":
            badgeColor = "danger"; // red
            break;
          case "Not Applied":
          case "Suspended":
          default:
            badgeColor = "dark"; // black
            break;
        }

        return (
          <span
            className={`badge badge-pill bg-${badgeColor}`}
            style={{ cursor: "pointer" }}
          >
            {row.kyc_status}
          </span>
        );
      },
    },
    {
      name: "Status",
      cell: (row) => (
        <div
          style={{ marginTop: "10px", marginBottom: "10px" }}
          onClick={() => {
            changeStatusHandler(row.id);
          }}
        >
          {(() => {
            if (row.status === "Active") {
              return (
                <span class="badge badge-pill badge-success">{row.status}</span>
              );
            } else if (row.status === "Inactive") {
              return (
                <span class="badge badge-pill badge-danger">{row.status}</span>
              );
            } else {
              return (
                <span class="badge badge-pill badge-warning">{row.status}</span>
              );
            }
          })()}
        </div>
      ),
    },
    {
      name: "Registration Date",
      cell: (row) => (
        <div style={{ marginTop: "10px", marginBottom: "10px" }}>
          <span>{row.created_on}</span>
        </div>
      ),
    },
    {
      name: "More Action",
      cell: (row) => (
        <div>
          {userType === "Admin" && (
            <button
              type="button"
              class="btn btn-success btn-sm"
              onClick={() => {
                history.push("/admin/wallet_topup/" + row.user_id);
              }}
            >
              <i class="fas fa-wallet"></i>
            </button>
          )}
          <button
            type="button"
            class="btn btn-primary btn-sm ml-1"
            onClick={() => {
              history.push("/admin/user_profile/" + row.user_id);
            }}
          >
            <i class="fas fa-edit"></i>
          </button>
          {userType === "Admin" && (
            <button
              type="button"
              class="btn btn-secondary btn-sm ml-1"
              onClick={() => {
                setSelectedData(row);
                setOpenUserDetailsDialog(true);
              }}
            >
              <i class="fas fa-eye"></i>
            </button>
          )}
          {userType === "Admin" && (
            <button
              type="button"
              class="btn btn-danger btn-sm ml-1"
              onClick={() => {
                Swal.fire({
                  title: "Are you sure to delete?",
                  showCancelButton: true,
                  confirmButtonText: `Delete`,
                  confirmButtonColor: "red",
                }).then((result) => {
                  if (result.isConfirmed) {
                    //  deleteUserHandler(selectedData.id);
                  }
                });
              }}
            >
              <i class="fas fa-trash-alt"></i>
            </button>
          )}
        </div>

        // <div>
        //   <IconButton
        //     color="primary"
        //     id="basic-button"
        //     aria-controls={open ? "basic-menu" : undefined}
        //     aria-haspopup="true"
        //     aria-expanded={open ? "true" : undefined}
        //     onClick={(event) => {
        //       handleClick(event);
        //       setSelectedData(row);
        //     }}
        //   >
        //     <MenuOpenIcon />
        //   </IconButton>

        //   <IconButton
        //     color="primary"
        //     aria-label="upload picture"
        //     component="span"
        //     onClick={() => {
        //       setUserData(row);
        //       setOpenUserDetailsDialog(true);
        //     }}
        //   >
        //     <ViewListIcon />
        //   </IconButton>

        //   <IconButton
        //     color="primary"
        //     aria-label="upload picture"
        //     component="span"
        //     onClick={() => {
        //       history.push("/admin/user_profile/" + row.user_id);
        //     }}
        //   >
        //     <EditIcon />
        //   </IconButton>

        //   <IconButton
        //     color="primary"
        //     aria-label="upload picture"
        //     component="span"
        //     onClick={() => {
        //       history.push("/admin/wallet_topup/" + row.user_id);
        //     }}
        //   >
        //     <WalletIcon color="secondary" />
        //   </IconButton>

        //   <IconButton
        //     color="primary"
        //     aria-label="upload picture"
        //     component="span"
        //     onClick={async () => {
        //       Swal.fire({
        //         title: "Are you sure you want to delete account?",
        //         text: `User ID: ${row.user_id} / Name: ${row.name}`,
        //         icon: "warning",
        //         showCancelButton: true,
        //         confirmButtonColor: "#3085d6",
        //         confirmButtonColor: "red",
        //         confirmButtonText: "Yes, delete it!",
        //       }).then((result) => {
        //         if (result.isConfirmed) {
        //           deleteUserHandler(row.id);
        //         }
        //       });
        //     }}
        //   >
        //     <DeleteIcon color="error" />
        //   </IconButton>

        //   <Menu
        //     id="basic-menu"
        //     anchorEl={anchorEl}
        //     open={open}
        //     onClose={handleClose}
        //     MenuListProps={{
        //       "aria-labelledby": "basic-button",
        //     }}
        //   >
        //     {/* <MenuItem
        //       onClick={() => {
        //         //  autoLoginHandler(selectedData.user_id);
        //       }}
        //     >
        //       Login to User Panel
        //     </MenuItem> */}
        //     {/*
        //     <MenuItem
        //       onClick={() => {
        //         window.open(
        //           "/admin/wallet_transactions/" + selectedData.user_id,
        //           "_blank"
        //         );
        //       }}
        //     >
        //       Wallet Transactions
        //     </MenuItem>

        //     <MenuItem
        //       onClick={() => {
        //         window.open(
        //           "/admin/pg_report/" + selectedData.user_id,
        //           "_blank"
        //         );
        //       }}
        //     >
        //       PG Report
        //     </MenuItem>

        //     <MenuItem
        //       onClick={() => {
        //         window.open(
        //           "/admin/recharge_report/" + selectedData.user_id,
        //           "_blank"
        //         );
        //       }}
        //     >
        //       Recharge Report
        //     </MenuItem> */}

        //     <MenuItem
        //       onClick={() => {
        //         window.open(
        //           "/admin/user_details/" + selectedData.user_id,
        //           "_blank"
        //         );
        //       }}
        //     >
        //       Print User Details
        //     </MenuItem>

        //     <MenuItem
        //       onClick={() => {
        //         window.open(
        //           "/admin/reset_login_details/" + selectedData.user_id,
        //           "_blank"
        //         );
        //       }}
        //     >
        //       Reset Login Details
        //     </MenuItem>

        //     {/* <MenuItem
        //       onClick={() => {
        //         history.push("/admin/send_wp_message/" + selectedData.id);
        //       }}
        //     >
        //       Send Whatsapp Msg
        //     </MenuItem> */}

        //     {/* {userType === "Admin" && (
        //       <MenuItem
        //         onClick={() => {
        //           Swal.fire({
        //             title: "Are you sure to delete?",
        //             showCancelButton: true,
        //             confirmButtonText: `Delete`,
        //             confirmButtonColor: "red",
        //           }).then((result) => {
        //             if (result.isConfirmed) {
        //               //    deleteUserHandler(selectedData.id);
        //             }
        //           });
        //         }}
        //       >
        //         Delete User
        //       </MenuItem>
        //     )} */}
        //   </Menu>
        // </div>
      ),
    },
  ];

  const deleteUserHandler = async (id) => {
    loadingCtx.startLoading();

    try {
      const token = AuthService.getAccessToken();

      const responseData = await UserService.deleteUser(token, id);
      const status = responseData.status;
      const message = responseData.message;

      if (status === "SUCCESS") {
        Swal.fire("Success!", message, "success");
      } else {
        Swal.fire("Opps!", message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      Swal.fire("Opps!", errMsg, "error");
    }
    loadingCtx.stopLoading();
  };

  const [openUserDetailsDialog, setOpenUserDetailsDialog] = useState(false);

  return (
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-default">
              <div class="card-header">
                <h3 class="card-title">User Details</h3>
              </div>

              <div class="card-body">
                <DataTableComponent
                  noHeader={true}
                  columns={columns}
                  data={userData}
                  progressPending={userFetchLoading}
                  highlightOnHover
                  pagination
                  paginationServer
                  paginationTotalRows={1}
                  paginationPerPage={10}
                  onChangePage={(page) => {
                    // setPage(page);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <UserDetailsDialog
        openUserDetailsDialog={openUserDetailsDialog}
        setOpenUserDetailsDialog={setOpenUserDetailsDialog}
        userData={selectedData}
      />
    </section>
  );
};

export default UserDetailsSection;
